// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export function acknowledgmentProgress(recipientIds, acknowledgedUserIds) {
    const acked = new Set(acknowledgedUserIds);
    if (!Array.isArray(recipientIds)) {
        return {
            recorded: false,
            total: 0,
            acknowledged: acked.size,
            pending_user_ids: [],
            percentage: null,
        };
    }
    const recipients = [...new Set(recipientIds)];
    const pending = recipients.filter((id) => !acked.has(id));
    const acknowledged = recipients.length - pending.length;
    return {
        recorded: true,
        total: recipients.length,
        acknowledged,
        pending_user_ids: pending,
        percentage: recipients.length > 0 ? Math.round((acknowledged / recipients.length) * 100) : null,
    };
}
//# sourceMappingURL=acknowledgment-progress.js.map